import styled from "styled-components";

export const StyledPageLoader = styled.div`
  //margin-top: 71px;
`;
